module.exports = __webpack_public_path__ + "img/flowersetting_03.8e29c2e5.jpg";